import React, { useEffect } from 'react'
import { subscribe } from 'react-contextual'
import { PortfoliosProvider } from '../../../providers'
import Portfolios from './Portfolios/Portfolios'

interface PortfoliosPageProps {
  getPortfolios: (searchQuery: string) => void
  searchQuery: string
}

const PortfoliosPage = ({ getPortfolios, searchQuery }: PortfoliosPageProps): React.ReactElement => {
  useEffect(() => {
    getPortfolios(searchQuery)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Portfolios />
}

export default subscribe(PortfoliosProvider, ({ getPortfolios, searchQuery }: PortfoliosPageProps) => ({
  getPortfolios,
  searchQuery,
}))(PortfoliosPage)
